import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import config from '../../../config'
import Header from '../Header';
import Footer from '../../Pages/Footer';
import Nofees from '../../Pages/Presale/IconBox/Nofees'
import Multiswap from '../../Pages/Presale/IconBox/Multiswap'
import AccordionBox from '../../Pages/Presale/Accordion'
import Oneclickswap from '../../Pages/Presale/IconBox/Oneclickswap'
import '../../Dashboard/css/swap.css';
import { Container, Row, Col, Card, Nav, Form, Button, Tabs, Tab, Modal,InputGroup } from 'react-bootstrap';
import ExchangeIcon from '../../Pages/Presale/IconBox/ExchangeIcon';
import { LiaAngleDownSolid } from "react-icons/lia";
import { IoSearch } from "react-icons/io5";



const Liquiditypool = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const inputstyle = {
        paddingLeft:"40px",
        backgroundColor:"#85DEF51A",
        border:"1px solid #85DEF51A",
        borderRadius:"10px"
      };

    return (
        <>
            <Header />

            <div className='subheader'>
                <img src='assets/images/liquidity_banner.png' width={`100%`} />
            </div>
            <div className="dashboard pt-5 pb-5 position-relative">
              
                <section className="pb-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <Row className='align-items-center'>
                                    <Col lg={6} xs={6}>
                                        <h1 className='mb-0'>Your V2 Liquidity</h1>
                                    </Col>
                                    <Col lg={6} xs={6} className='text-right'>
                                        <Button variant='primary'>Add V2 Liquidity</Button>
                                    </Col>
                                </Row>
                                <Row className='py-5'>
                                    <Col lg={12}>
                                        <div className='text-center'>
                                            <img src='assets/images/icon/docsearch.svg'width={`110`}/>
                                            <h4 className='mt-3'>No Liquidity found</h4>
                                        </div>
                                    </Col>
                                </Row>
                                
                            </Col>
                            
                        </Row>
                    </Container>

                </section>
            </div>
            <Footer bg="bg-primary" />

        </>
    )
}

export default Liquiditypool;
